import React from 'react';
import { Grid, Typography, Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonTable from 'components/commonTable/CommonTable';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import Loader from 'components/loader/Loader';

export default function TabVendor({
  onTabChange,
  TableData,
  onClickTable,
  value,
  moreIconData,
  onClickMoreIcon,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  rowsPerPage,
  onFilterChange,
  onRestFilter,
  filterdata,
  onSearch,
  loaderDriver,
  loaderVehicle,
  loadersubVendor,
  loaderUser,
  defaultStatus,
  search,
}) {
  const handleChange = (event, newValue) => {
    onTabChange(newValue); // Call the onTabChange callback with the new tab value
  };

  const onClickTableRow = (navigate, val) => {
    onClickTable(navigate, val);
  };

  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle mt10"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' },
                  }}
                >
                  <Tab label="Driver" value="2" className="tabStyle" />
                  <Tab label="Vehicle" value="3" className="tabStyle" />
                  <Tab label="User" value="4" className="tabStyle" />
                  <Tab label="Sub-Vendor" value="1" className="tabStyle" />
                </TabList>
              </Grid>
              <Grid
                item
                container
                xs={6}
                spacing={1}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item xs={7}>
                  <SearchBar onSearchQuery={onSearch} search={search} />
                </Grid>
                <Grid item>
                  {value !== '4' && (
                    <CommonFilter
                      filterdata={filterdata}
                      onFilterChange={onFilterChange}
                      onRestFilter={onRestFilter}
                      defaultStatus={defaultStatus}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>

            <TabPanel value="1" className="vendotTable tabPanelStyle">
              {loadersubVendor ? (
                <Loader />
              ) : (
                <CommonTable
                  data={TableData}
                  tableOnClickRow={onClickTableRow}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  moreIconData={moreIconData}
                  onClickMoreIcon={onClickMoreIcon}
                  isClickable={true}
                  viewMoreIcon={false}
                  tabName={'subVendorTable'}
                />
              )}
            </TabPanel>
            <TabPanel value="2" className="vendotTable tabPanelStyle">
              {loaderDriver ? (
                <Loader />
              ) : (
                <CommonTable
                  data={TableData}
                  tableOnClickRow={onClickTableRow}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  moreIconData={moreIconData}
                  onClickMoreIcon={onClickMoreIcon}
                  isClickable={true}
                  viewMoreIcon={false}
                  tabName={'driver'}
                />
              )}
            </TabPanel>
            <TabPanel value="3" className="vendotTable tabPanelStyle">
              {loaderVehicle ? (
                <Loader />
              ) : (
                <CommonTable
                  data={TableData}
                  tableOnClickRow={onClickTableRow}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  moreIconData={moreIconData}
                  onClickMoreIcon={onClickMoreIcon}
                  tabName={'vehicle'}
                  isClickable={true}
                />
              )}
            </TabPanel>
            <TabPanel value="4" className="vendotTable tabPanelStyle">
              <Typography>
                {loaderUser ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={TableData}
                    tableOnClickRow={onClickTableRow}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    moreIconData={moreIconData}
                    onClickMoreIcon={onClickMoreIcon}
                    isClickable={false}
                  />
                )}
              </Typography>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}
